import { render } from "./GiftBox.vue?vue&type=template&id=7a17ac92&scoped=true"
import script from "./GiftBox.vue?vue&type=script&lang=js"
export * from "./GiftBox.vue?vue&type=script&lang=js"

import "./GiftBox.vue?vue&type=style&index=0&id=7a17ac92&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a17ac92"]])

export default __exports__